import React from 'react'
import { useDrag } from 'react-dnd'
import { Target, Users, MessageSquare, Activity } from 'lucide-react'
import usePracticeStore from '../../stores/practiceStore'

const TileType = {
  DRILL: 'drill',
  SCRIMMAGE: 'scrimmage',
  SPEAKING_POINTS: 'speaking-points',
  FITNESS: 'fitness'
}

const getDefaultTitle = (type) => {
  switch (type) {
    case TileType.DRILL:
      return 'New Drill'
    case TileType.SCRIMMAGE:
      return 'New Scrimmage'
    case TileType.SPEAKING_POINTS:
      return 'Speaking Points'
    case TileType.FITNESS:
      return 'New Fitness'
    default:
      return 'New Activity'
  }
}

const TileItem = ({ type, icon: Icon, label, colorClass, hoverColorClass, iconColorClass }) => {
  const { tiles, addTileAt } = usePracticeStore()
  
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'practice-tile',
    item: { tileType: type },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  }))

  const handleDoubleClick = () => {
    const newTile = {
      id: Date.now().toString(),
      type: type,
      title: getDefaultTitle(type),
      description: '',
      duration: 10 // Default 10 minutes duration
    }
    // Get sorted tiles to determine the correct index for adding at the bottom
    const sortedTiles = [...tiles].sort((a, b) => (a.startTime || 0) - (b.startTime || 0))
    // Add at the end of the sorted list
    addTileAt(newTile, sortedTiles.length)
  }

  return (
    <div
      ref={drag}
      onDoubleClick={handleDoubleClick}
      className={`flex items-center space-x-3 p-3 mb-3 rounded-lg border-2 border-dashed cursor-move transition-all ${
        isDragging
          ? 'opacity-50 border-blue-500 bg-blue-50'
          : `border-gray-300 ${hoverColorClass}`
      }`}
      title="Drag to add or double-click to add to bottom of session"
    >
      <Icon size={20} className={iconColorClass} />
      <span className="text-sm font-medium text-gray-700">{label}</span>
    </div>
  )
}

const TilePalette = () => {
  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Practice Tiles</h2>
      <p className="text-xs text-gray-600 mb-4">
        Drag or double-click to add tiles to the practice session on the right
      </p>
      
      <div className="space-y-2">
        <TileItem
          type={TileType.DRILL}
          icon={Target}
          label="Drill"
          hoverColorClass="hover:border-green-400 hover:bg-green-50"
          iconColorClass="text-green-600"
        />
        <TileItem
          type={TileType.SCRIMMAGE}
          icon={Users}
          label="Scrimmage"
          hoverColorClass="hover:border-blue-400 hover:bg-blue-50"
          iconColorClass="text-blue-600"
        />
        <TileItem
          type={TileType.SPEAKING_POINTS}
          icon={MessageSquare}
          label="Speaking Points"
          hoverColorClass="hover:border-purple-400 hover:bg-purple-50"
          iconColorClass="text-purple-600"
        />
        <TileItem
          type={TileType.FITNESS}
          icon={Activity}
          label="Fitness"
          hoverColorClass="hover:border-orange-400 hover:bg-orange-50"
          iconColorClass="text-orange-600"
        />
      </div>
    </div>
  )
}

export default TilePalette
export { TileType }

